import styled from 'particles/themes/styled'

export const ToolbarContainer = styled.div`
    display: flex;
    flex-direction: column;
    background: white;
    gap: ${({ theme }) => theme.spacing[400]};
    padding: ${({ theme }) => theme.spacing[300]};
    padding-bottom: 0px;
    .main-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .left-tools,
        .right-tools {
            display: flex;
            align-items: center;
        }

        .left-tools {
            gap: ${({ theme }) => theme.spacing[200]};
        }
    }
`

export const SubmissionFilterChipContainer = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[200]};
`
